// src/components/QuickLifingWidget.js
import React, { useState } from 'react'; 
import { db } from '../firebaseConfig';
import {
  collection,
  query,
  where,
  getDocs,
  writeBatch,
  increment,
  doc
} from 'firebase/firestore';
import { useTranslation } from 'react-i18next'; // <-- MODIFICA: Importa hook

// --- IMPORT MUI ---
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Alert
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

// Questo componente riceve la lista completa dei veicoli da DashboardHome
function QuickLifingWidget({ teamId, vehicles }) {
  // --- MODIFICA: Inizializza t() ---
  const { t } = useTranslation('dashboard');
  // --- FINE MODIFICA ---

  const [selectedVehicleId, setSelectedVehicleId] = useState('');
  const [usageValue, setUsageValue] = useState('');
  const [usageUnit, setUsageUnit] = useState('km');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feedback, setFeedback] = useState({ show: false, type: 'success', text: '' });

  // --- MODIFICA: Funzione handleAddBulkUsage (con t()) ---
  const handleAddBulkUsage = async (e) => {
    e.preventDefault();
    const numericUsage = Number(usageValue);

    if (!selectedVehicleId || !numericUsage || numericUsage <= 0) {
      setFeedback({ show: true, type: 'error', text: t('quick_lifing.error_select_vehicle') }); 
      return;
    }

    setIsSubmitting(true);
    setFeedback({ show: false });

    try {
      const componentsQuery = query(
        collection(db, "vehicleComponents"),
        where("vehicleId", "==", selectedVehicleId),
        where("unit", "==", usageUnit) 
      );
      const querySnapshot = await getDocs(componentsQuery);

      if (querySnapshot.empty) {
        setFeedback({ show: true, type: 'warning', text: t('quick_lifing.warn_no_components', { unit: usageUnit }) }); 
        setIsSubmitting(false);
        return;
      }

      const batch = writeBatch(db);
      querySnapshot.forEach((componentDoc) => {
        const componentRef = doc(db, "vehicleComponents", componentDoc.id);
        batch.update(componentRef, {
          currentUsage: increment(numericUsage)
        });
      });

      await batch.commit();

      setFeedback({ show: true, type: 'success', text: t('quick_lifing.success_update', { count: querySnapshot.size, usage: numericUsage, unit: usageUnit }) }); 
      setSelectedVehicleId('');
      setUsageValue('');

    } catch (error) {
      console.error("Error adding bulk lifing:", error); 
      setFeedback({ show: true, type: 'error', text: t('quick_lifing.error_generic') }); 
    }
    setIsSubmitting(false);
  };
  // --- FINE MODIFICA ---

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        p: 3,
        minHeight: 200,
        border: '1px solid',
        borderColor: 'divider',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography variant="h6" gutterBottom>{t('quick_lifing.title')}</Typography>
      
      <Box 
        component="form" 
        onSubmit={handleAddBulkUsage}
        sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          gap: 2.5,
          mt: 1,
          flexGrow: 1
        }}
      >
        {/* 1. Selezione Veicolo */}
        <FormControl fullWidth>
          <InputLabel id="vehicle-select-label">{t('quick_lifing.vehicle_label')}</InputLabel>
          <Select
            labelId="vehicle-select-label"
            value={selectedVehicleId}
            label={t('quick_lifing.vehicle_label')}
            onChange={(e) => setSelectedVehicleId(e.target.value)}
            required
          >
            {vehicles.length === 0 && (
              <MenuItem value="" disabled><em>{t('quick_lifing.vehicle_loading')}</em></MenuItem>
            )}
            {vehicles.map((v) => (
              <MenuItem key={v.id} value={v.id}>
                {v.marca} {v.modello} (Nr. {v.numeroGara || 'N/A'})
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* 2. Box orizzontale per Valore e Unità */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            label={t('quick_lifing.value_label')}
            type="number"
            value={usageValue}
            onChange={(e) => setUsageValue(e.target.value)}
            required
            sx={{ flexGrow: 1 }}
          />
          <FormControl sx={{ width: '120px' }}>
            <InputLabel id="unit-select-label">{t('quick_lifing.unit_label')}</InputLabel>
            <Select
              labelId="unit-select-label"
              value={usageUnit}
              label={t('quick_lifing.unit_label')}
              onChange={(e) => setUsageUnit(e.target.value)} 
            >
              <MenuItem value="km">{t('quick_lifing.unit_km')}</MenuItem>
              <MenuItem value="hours">{t('quick_lifing.unit_hours')}</MenuItem> 
            </Select>
          </FormControl>
        </Box>

        {/* 3. Bottone */}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={isSubmitting}
          startIcon={isSubmitting ? <CircularProgress size={20} /> : <AddCircleOutlineIcon />}
          fullWidth
          size="large"
          sx={{ mt: 'auto', height: '56px' }}
        >
          {t('quick_lifing.apply_button')}
        </Button>
      </Box>
      
      {feedback.show && (
        <Alert severity={feedback.type} sx={{ mt: 2, width: '100%' }}>
          {feedback.text}
        </Alert>
      )}
    </Paper>
  );
}

export default QuickLifingWidget;